import { Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const AdoptGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If you already own at least 1 Miner Mole, you have fulfilled this quest and ready to move to the next!')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          "If you don't already own a Mole, you can click on the button below to go to VVS Miner Mole's Minted page. Alternatively, you can buy a Mole on any available secondary NFT marketplace",
        )}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Buy any Miner Mole NFT of your choice')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 4')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If the above transaction is successful, you have fulfilled this quest')}
      </Text>
    </>
  )
}
